export default "__VITE_ASSET__YGShjX6K__"